import { z } from 'zod';

export const addOnZ = z.object({
  title: z.string().min(1, 'Title is required'),
  description: z.string().min(1, 'Description is required'),
  priceInCents: z.string().min(1, 'Price is required'),
  archived: z.boolean().optional(),
  customerVisible: z.boolean().default(true),
});

export type AddOnFormValues = z.infer<typeof addOnZ>;
